export var SegmentEnum;
(function (SegmentEnum) {
    SegmentEnum["SINGLE"] = "SINGLE";
    SegmentEnum["DOUBLE"] = "DOUBLE";
    SegmentEnum["TRIPLE"] = "TRIPLE";
})(SegmentEnum || (SegmentEnum = {}));
